module.exports = __webpack_public_path__ + "workspace/static/img/firefox.51aa5b5.svg";